import React from 'react'

import { SvgProps } from './types'

function Unpin3Svg({
  width,
  height,
  className,
  stroke,
  strokeColor,
}: SvgProps) {
  return (
    <svg
      width={width || '40'}
      height={height || '40'}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      strokeWidth={stroke || 1.6}
      stroke="currentColor"
      fill="none"
      className={className}
      strokeMiterlimit={10}
    >
      <path
        d="M7.91667 12.0833L2.5 17.5"
        stroke={strokeColor}
        strokeWidth={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.39717 6.57434L5.58143 6.48986L4.16721 7.90408L11.8275 15.5644L13.2417 14.1502L13.1571 13.333M9.57106 5.83301L12.6311 2.22585L17.5059 7.10059L13.9164 10.1455"
        stroke={strokeColor}
        strokeWidth={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.5 2.5L17.5 17.5"
        stroke={strokeColor}
        strokeWidth={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default Unpin3Svg
